import script from "./FlowBuilderAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./FlowBuilderAgent.vue?vue&type=script&setup=true&lang=js"

import "./FlowBuilderAgent.vue?vue&type=style&index=0&id=2d8a2224&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d8a2224"]])

export default __exports__